import type {
  WhereCategory,
  WhereDataset,
  WhereField,
  WhereKind,
  WhereRelation,
} from '../types.js';

type Extra = Partial<Omit<WhereField, 'key' | 'label' | 'kind' | 'description' | 'category'>>;

/** A field builder for one menu category; a relation prefixes its keys (`project.city`). */
export function fieldsIn(category: WhereCategory, relation?: WhereRelation) {
  return (
    key: string,
    label: string,
    kind: WhereKind,
    description: string,
    extra: Extra = {},
  ): WhereField => ({
    key: relation ? `${relation}.${key}` : key,
    label,
    category,
    kind,
    description,
    ...(relation ? { relation } : {}),
    ...extra,
  });
}

/** The Your workspace and Saved Views entries every dataset shares. */
export function workspaceFields(dataset: WhereDataset): WhereField[] {
  const w = fieldsIn('workspace');
  const fields: WhereField[] = [
    w('workspace_status', 'Status', 'choice', "Your workspace's own status.", {
      source: 'statuses',
    }),
    w('tags', 'Tags', 'choice', "Your workspace's own tags.", { source: 'tags' }),
  ];
  if (dataset !== 'contact') {
    fields.push(w('following', 'Following', 'yes_no', "In your workspace's Following list."));
  }
  if (dataset === 'account') {
    fields.push(
      w(
        'last_activity',
        'Last activity',
        'date',
        'Newest signal of a type you follow, on any of their projects.',
      ),
    );
  }
  fields.push(
    fieldsIn('views')('view', 'In a saved View', 'choice', 'In one of your saved Views.', {
      source: 'views',
    }),
  );
  return fields;
}
